// lib/date-fns.ts

import { formatInTimeZone } from 'date-fns-tz'
import { enGB, es, fr, pt } from 'date-fns/locale'
import type { Locale } from 'date-fns'

export type SupportedLocale = 'en-GB' | 'pt-PT' | 'fr' | 'es'

export function format(
  date: Date | string | number,
  formatStr: string,
  options?: { locale?: Locale },
): string {
  return formatInTimeZone(date, 'Europe/Lisbon', formatStr, options)
}

export function formatInUTC(
  date: Date | string | number,
  formatStr: string,
  options?: { locale?: Locale },
): string {
  return formatInTimeZone(date, 'UTC', formatStr, options)
}

export function dateFnsLocale(locale: string): Locale | undefined {
  const map: Record<SupportedLocale, Locale> = {
    'en-GB': enGB,
    'pt-PT': pt,
    fr: fr,
    es: es,
  }

  return map[locale as SupportedLocale] ?? enGB
}

export function getDateFormat(locale: string): string {
  const map: Record<SupportedLocale, string> = {
    'en-GB': 'EEEE do',
    'pt-PT': 'EEEE dd',
    fr: 'EEEE dd',
    es: 'EEEE dd',
  }
  return map[locale as SupportedLocale] ?? map['en-GB']
}

export function formatDate(date: Date): string {
  let month = `${date.getMonth() + 1}`
  let day = `${date.getDate()}`
  const year = `${date.getFullYear()}`

  if (month.length < 2) month = `0${month}`
  if (day.length < 2) day = `0${day}`

  return [year, month, day].join('-')
}

export function formatTime(date: Date): string {
  let hours = `${date.getHours()}`
  let minutes = `${date.getMinutes()}`

  if (hours.length < 2) hours = `0${hours}`
  if (minutes.length < 2) minutes = `0${minutes}`

  return `${hours}:${minutes}`
}
